import { render, staticRenderFns } from "./HomeCarouselComponent.vue?vue&type=template&id=a66e0466&"
import script from "./HomeCarouselComponent.vue?vue&type=script&lang=js&"
export * from "./HomeCarouselComponent.vue?vue&type=script&lang=js&"
import style0 from "./HomeCarouselComponent.vue?vue&type=style&index=0&id=a66e0466&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCarousel,VCarouselItem,VCol,VContainer,VImg,VRow})
